import React from 'react';
import PropTypes from 'prop-types';
import useLocale from '@/hooks/useLocale';
import {
  ProtectionCardRoot,
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardTitle,
  ProtectionCardDescription,
  ProtectionCardActions,
  ProtectionCardButton,
  ProtectionCardMonarx,
} from '../ProtectionCardCompound';

const ProtectionCardVariantTrialIsActive = ({
  testId,
  hideButtons,
  onActivateProtectionPro,
}) => {
  const { gatorProtect } = useLocale();
  const summary = gatorProtect && gatorProtect.summary;
  const block = summary && summary.protectionCard && summary.protectionCard.trialIsActive;

  if (!block) {
    return null;
  }

  const activatePro = block.actions && block.actions[0];
  const actionsTestId = `${testId}__actions`;

  return (
    <ProtectionCardRoot testId={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={block.title} />
        <ProtectionCardTextBlock>
          <ProtectionCardTitle>{block.title}</ProtectionCardTitle>
          <ProtectionCardDescription html={block.description} />
          {!hideButtons && activatePro && (
            <ProtectionCardActions actionsTestId={actionsTestId}>
              <ProtectionCardButton
                variant={activatePro.variant}
                hasMultipleButtons={false}
                onClick={onActivateProtectionPro}
                testId={`${testId}__action-${activatePro.key}`}
              >
                {activatePro.label}
              </ProtectionCardButton>
            </ProtectionCardActions>
          )}
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={block.title} />
    </ProtectionCardRoot>
  );
};

ProtectionCardVariantTrialIsActive.propTypes = {
  testId: PropTypes.string,
  hideButtons: PropTypes.bool,
  onActivateProtectionPro: PropTypes.func,
};

ProtectionCardVariantTrialIsActive.defaultProps = {
  testId: 'protection-card',
  hideButtons: false,
  onActivateProtectionPro: undefined,
};

export default ProtectionCardVariantTrialIsActive;
